import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationAttributesTable from '../components/OrganisationAttributesTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';

import axios from 'axios';
import {
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './OrganisationAttributes.css';

class OrganisationAttributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            attributes: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            emailAttribute: this.props.emailAttribute,
            // Individual selection mode: tracks which specific attributes are selected
            selectedAttributes: new Set(),           // UUIDs of individually selected attributes
            selectedAttributesData: new Map(),       // UUID -> attribute object data for selected attributes
            // Select-all mode: tracks global selection with exclusions
            selectAllMode: false,                    // true = "select all", false = individual selection
            selectAllPages: false,                   // true = select across ALL pages
            totalAttributes: 0,                      // total count across all pages
            excludedAttributes: new Set(),           // UUIDs of attributes excluded from "select all"
            excludedAttributesData: new Map()        // UUID -> attribute object data for excluded attributes
        };
    }

    componentDidMount() {
        this.loadOrganisationInformation();
        this.loadOrganisationAttributesFromServer();
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    deleteAttribute(attribute) {
        const { uuid } = this.props.match.params;

        var self = this;
        axios
            .delete(
                `${config.baseURL}/organisations/${uuid}/attributes/${
                    attribute.uuid
                }`
            )
            .then(function(response) {
                self.loadOrganisationAttributesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationAttributesFromServer() {
        var self = this;
        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}/attributes`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search,
                    emailAttribute: self.state.emailAttribute
                }
            })
            .then(function(response) {
                console.log(
                    `Attributes: ${JSON.stringify(response.data.attributes)}`
                );
                self.setState({
                    attributes: response.data.attributes,
                    pageCount: response.data.pageCount,
                    totalAttributes: response.data.itemCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOrganisationAttributesFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');
        }

        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadOrganisationAttributesFromServer();
    };

    handleSelectAttribute = (attributeUuid, isSelected) => {
        let selectedAttributes = new Set(this.state.selectedAttributes);
        let selectedAttributesData = new Map(this.state.selectedAttributesData);
        let excludedAttributes = new Set(this.state.excludedAttributes);
        let excludedAttributesData = new Map(this.state.excludedAttributesData);
        
        if (isSelected) {
            if (this.state.selectAllMode) {
                // In "select all" mode: checking a box means "un-exclude" this item
                // Remove from exclusion list so it gets included in bulk operation
                excludedAttributes.delete(attributeUuid);
                excludedAttributesData.delete(attributeUuid);
            } else {
                // In individual mode: checking a box means "select" this item
                // Add to individual selection list
                selectedAttributes.add(attributeUuid);
                const attributeData = this.state.attributes.find(attr => attr.uuid === attributeUuid);
                if (attributeData) {
                    selectedAttributesData.set(attributeUuid, attributeData);
                }
            }
        } else {
            if (this.state.selectAllMode) {
                // In "select all" mode: unchecking a box means "exclude" this item
                // Add to exclusion list so it gets skipped in bulk operation
                excludedAttributes.add(attributeUuid);
                const attributeData = this.state.attributes.find(attr => attr.uuid === attributeUuid);
                if (attributeData) {
                    excludedAttributesData.set(attributeUuid, attributeData);
                }
            } else {
                // In individual mode: unchecking a box means "deselect" this item
                // Remove from individual selection list
                selectedAttributes.delete(attributeUuid);
                selectedAttributesData.delete(attributeUuid);
            }
        }
        
        this.setState({ 
            selectedAttributes, 
            selectedAttributesData,
            excludedAttributes,
            excludedAttributesData
        });
    };

    handleSelectAll = (isSelectAll) => {
        if (isSelectAll) {
            // Select all items on current page only - DON'T set selectAllMode yet
            const currentPageAttributeUuids = new Set(this.state.attributes.map(attr => attr.uuid));
            const currentPageAttributesData = new Map(this.state.attributes.map(attr => [attr.uuid, attr]));

            this.setState({
                selectAllMode: false,  // Keep this false - only for current page
                selectAllPages: false,
                selectedAttributes: currentPageAttributeUuids,
                selectedAttributesData: currentPageAttributesData,
                excludedAttributes: new Set(),
                excludedAttributesData: new Map()
            });
        } else {
            this.setState({
                selectAllMode: false,
                selectAllPages: false,
                selectedAttributes: new Set(),
                selectedAttributesData: new Map(),
                excludedAttributes: new Set(),
                excludedAttributesData: new Map()
            });
        }
    };

    handleSelectAllPages = () => {
        this.setState({
            selectAllMode: true,   // NOW we set selectAllMode true
            selectAllPages: true,
            selectedAttributes: new Set(),
            selectedAttributesData: new Map()
        });
    };

    showBulkDeleteConfirmation = () => {
        const { t } = this.props;

        let bodyContent;

        if (this.state.selectAllPages) {
            const effectiveCount = this.state.totalAttributes - this.state.excludedAttributes.size;
            bodyContent = (
                <div>
                    <p><strong>Warning: This will delete {effectiveCount} attributes across all pages!</strong></p>
                    <p>This includes all attributes that match your current search {this.state.search ? ` for "${this.state.search}"` : ''}
                    {this.state.excludedAttributes.size > 0 && <span>, excluding {this.state.excludedAttributes.size} manually deselected items</span>}.</p>
                    <p><em>This action cannot be undone.</em></p>
                </div>
            );
        } else {
            const selectedItems = Array.from(this.state.selectedAttributesData.values());
            bodyContent = (
                <div>
                    <p><strong>This will delete {selectedItems.length} selected attribute{selectedItems.length === 1 ? '' : 's'}:</strong></p>
                    <ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                        {selectedItems.map(item => (
                            <li key={item.uuid}><strong>{item.name}</strong></li>
                        ))}
                    </ul>
                </div>
            );
        }
        
        this.dialog.show({
            title: t('Dialog.warning'),
            body: bodyContent,
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.confirmBulkDelete(),
                    'btn-danger'
                )
            ],
            bsSize: 'large'
        });
    };

    handleBulkDelete = () => {
        this.showBulkDeleteConfirmation();
    };

    confirmBulkDelete = () => {
        const { uuid } = this.props.match.params;

        // Determine if we're using "select all" mode (either current page or all pages)
        const usingSelectAll = this.state.selectedAttributes.size > 0 || this.state.selectAllPages;

        const payload = {
            selectAll: usingSelectAll,
            selectAllPages: this.state.selectAllPages,
            search: this.state.search,
            emailAttribute: this.state.emailAttribute,
            attributes: this.state.selectAllPages ? [] : Array.from(this.state.selectedAttributes),
            excludedAttributes: this.state.selectAllPages ? Array.from(this.state.excludedAttributes) : []
        };

        console.log('🔍 BULK DELETE PAYLOAD:', {
            selectAll: payload.selectAll,
            selectAllPages: payload.selectAllPages,
            itemsCount: payload.attributes ? payload.attributes.length : 0,
            items: payload.attributes,
            excludedItemsCount: payload.excludedAttributes.length,
            search: payload.search,
            state: {
                selectedItemsSize: this.state.selectedAttributes ? this.state.selectedAttributes.size : 0,
                selectAllPages: this.state.selectAllPages,
                totalItems: this.state.totalAttributes
            }
        });

        const wasSelectAllPagesWithSearch = this.state.selectAllPages && this.state.search;

        axios
            .post(`${config.baseURL}/organisations/${uuid}/attributes/bulk-delete`, payload)
            .then((response) => {
                const newState = {
                    selectedAttributes: new Set(),
                    selectedAttributesData: new Map(),
                    excludedAttributes: new Set(),
                    excludedAttributesData: new Map(),
                    selectAllMode: false,
                    selectAllPages: false
                };

                if (wasSelectAllPagesWithSearch) {
                    newState.search = '';

                    const url = new URL(window.location.href);
                    url.searchParams.delete('search');
                    window.history.pushState(null, null, url);
                }

                // Set all state at once, then reload
                this.setState(newState, () => {
                    this.loadOrganisationAttributesFromServer();
                });
                
                this.dialog.hide();
            })
            .catch(error => {
                console.log(error);
            });
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'OrganisationAttributes.title'
        )}`;

        const user = this.state.user;
        const { uuid } = this.props.match.params;

        const attributepath = this.props.emailAttribute ? "emailattributes" : "attributes";

        // Calculate effective selection count based on mode:
        // - selectAllMode: total items minus excluded items = "select all except these"
        // - individual mode: just count the individually selected items
        const selectedCount = this.state.selectAllPages
            ? this.state.totalAttributes - this.state.excludedAttributes.size
            : this.state.selectedAttributes.size;
        const hasSelection = selectedCount > 0;

        // Show banner when: all items on current page are selected AND there are more pages
        const allCurrentPageSelected = this.state.selectedAttributes.size === this.state.attributes.length && this.state.attributes.length > 0;
        const showSelectAllPagesBanner = allCurrentPageSelected && !this.state.selectAllPages && this.state.totalAttributes > this.state.attributes.length;

        return (
            <div className="OrganisationAttributes">
                <Dialog ref={el => { this.dialog = el; }} />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                {this.props.emailAttribute ? (

                                    t('SideNavigation.emailattributes')

                                    ) :  t('SideNavigation.attributes')}
                                    {' '}
                                    <small>
                                        {this.state.organisation_name}
                                    </small>
                                    {this.state.userIsAuthorized(user, [
                                        'staff_super_admin',
                                        'staff_admin',
                                        'organisation_admin',
                                        'organisation_user'
                                    ]) ? (
                                        <Link
                                            type="submit"
                                            className="btn btn-primary"
                                            to={`/organisations/${uuid}/${attributepath}/create`}
                                        >
                                            <em className="fa fa-plus fa-fw" />{' '}
                                            {t(
                                                'OrganisationAttributes.add_attribute'
                                            )}
                                        </Link>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>

                                    <li className="active">
                                        <i className="fa fa-tags" />{' '}
                                    {this.state.emailAttribute ? (

                                        t('SideNavigation.emailattributes')

                                    ) :  t('SideNavigation.attributes')}

                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
                                                    <form
                                                        role="search"
                                                        onSubmit={this.handleSubmit}
                                                        style={{ flex: hasSelection ? 1 : 1 }}
                                                    >
                                                        <FormGroup controlId="search" style={{ margin: 0 }}>
                                                            <InputGroup style={{ height: '38px' }}>
                                                                <FormControl
                                                                    type="text"
                                                                    value={this.state.search}
                                                                    onChange={this.handleChange}
                                                                    placeholder={t('Search')}
                                                                    style={{ height: '38px' }}
                                                                />
                                                                <InputGroup.Button>
                                                                    <Button 
                                                                        onClick={this.handleSubmit}
                                                                        style={{ height: '38px' }}
                                                                    >
                                                                        <i className="glyphicon glyphicon-search" />
                                                                    </Button>
                                                                </InputGroup.Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </form>

                                                    {hasSelection && (
                                                        <div className="alert alert-info" style={{ 
                                                            display: 'flex', 
                                                            justifyContent: 'space-between', 
                                                            alignItems: 'center', 
                                                            margin: 0, 
                                                            padding: '8px 16px',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            flex: 2,
                                                            minWidth: '350px',
                                                            height: '38px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span>
                                                                <strong>{selectedCount}</strong> attribute(s) selected
                                                                {this.state.selectAllPages && <span> (all pages)</span>}
                                                                {showSelectAllPagesBanner && (
                                                                    <span>
                                                                        {' '}
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handleSelectAllPages();
                                                                            }}
                                                                            style={{ textDecoration: 'underline', color: '#31708f', fontWeight: 'bold' }}
                                                                        >
                                                                            Select all {this.state.totalAttributes} attributes?
                                                                        </a>
                                                                    </span>
                                                                )}
                                                            </span>
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                <Button
                                                                    className="btn-default btn-sm"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            selectedAttributes: new Set(),
                                                                            selectedAttributesData: new Map(),
                                                                            excludedAttributes: new Set(),
                                                                            excludedAttributesData: new Map(),
                                                                            selectAllMode: false,
                                                                            selectAllPages: false
                                                                        });
                                                                    }}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className='far fa-square' /> {t('MediaSnippetMediaLibrary.select_none')}
                                                                </Button>
                                                                <Button 
                                                                    className="btn-danger btn-sm"
                                                                    onClick={this.handleBulkDelete}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className="fa fa-trash" /> Delete Selected
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t('Pagination.previous')}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={'pages pagination'}
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                

                                    <OrganisationAttributesTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        attributes={this.state.attributes}
                                        uuid={uuid}
                                        onDelete={this.deleteAttribute.bind(
                                            this
                                        )}
                                        emailAttribute={this.state.emailAttribute}
                                        selectedAttributes={this.state.selectedAttributes}
                                        selectAllMode={this.state.selectAllMode}
                                        excludedAttributes={this.state.excludedAttributes}
                                        onSelectAttribute={this.handleSelectAttribute}
                                        onSelectAll={this.handleSelectAll}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(OrganisationAttributes);
